import { Button } from "@mui/material";
import LogoutTwoToneIcon from "@mui/icons-material/LogoutTwoTone";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  const handleClickLogout = () => {
    localStorage.removeItem("admin");
    navigate("/admin", {
      replace: true,
    });
  };

  return (
    <Button
      onClick={handleClickLogout}
      variant="contained"
      color="error"
      endIcon={<LogoutTwoToneIcon />}
    >
      Logout
    </Button>
  );
};

export default Logout;
